import type { State } from '../../types';
import _ from 'lodash';
import { personalDataItemsNotDeleted } from '../computers/personal-data-items-not-deleted';
import { assetsNotDeleted } from '../assets/assets-not-deleted';
import { computersNotDeleted } from '../computers/computers-not-deleted';
import type { InfosecDataItem } from '../../../pages/computers-page/infosec-procedure/infosecDataItem';
import type { InfosecStorageUnit } from '../../../pages/computers-page/infosec-procedure/infosecStorageUnit';
import { mappedDataItems } from '../../../models/pages/mapped-data-items';
import { mappedComputers } from '../../../models/pages/mapped-computers';
import { dataItemName } from '../../../models/pages/data-item-name';

export function calculateDataItems(state: State): InfosecDataItem[] {
  const locations = _.uniqBy(
    personalDataItemsNotDeleted(state)
      .filter((p) => p.type?.endsWith('.paperDocuments'))
      .map((p): InfosecStorageUnit => {
        return {
          uuid: p.storageLocation ?? '',
          name: p.storageLocation ?? '',
          unitType: 'locations',
          computerType: '',
          application: '',
          partnerUuid: '',
          networkUuid: '',
        };
      }),
    (e) => e.uuid,
  );
  const assets = assetsNotDeleted(state)
    .filter((a) => a.isConfirmedEntity)
    .map((a) => {
      return {
        uuid: a.uuid,
        name: a.name ?? '',
        number: a.number ?? '',
      };
    });
  const computers = mappedComputers(computersNotDeleted(state));

  return _.orderBy(
    mappedDataItems(personalDataItemsNotDeleted(state), computersNotDeleted(state), computers, assets, locations),
    [
      (o) => o.createdDateTime,
      (o) => {
        const dataItemName1 = dataItemName(o, computers, assets, locations);
        if (dataItemName1 === null) {
          console.log(o);
          return '?';
        }
        return dataItemName1?.toLowerCase() ?? '';
      },
      (o) => o.uuid,
    ],
  ).map((o) => ({ ...o, name: dataItemName(o, computers, assets, locations) ?? '' }));
}
